angular.module('iw.frontyard.signup')
    .directive('iwRemovePatternValidator', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.pattern = function (modelValue, viewValue) {
                    return true;
                };

            }
        };
    });
